<script lang="ts" setup>
import { computed } from 'vue'
import instanceNotification, {
	NotificationTab,
	NotificationType,
} from '@/assets/ts/notification'
import BsTabContainer from '@/legacy/components/TabContainer.vue'
import BsTab from '@/legacy/components/Tab.vue'
import getTextFromConsole from '@/legacy/ts/getTextFromConsole'

const typeList = computed(() => {
	return [
		{
			id: NotificationTab.ALL,
			type: NotificationType.all,
			name: getTextFromConsole('notification_type_title_all'),
			count: instanceNotification.listAllUnread.length,
		},
		{
			id: NotificationTab.NOTIFICATION_TYPE_CORE,
			type: NotificationType.order,
			name: getTextFromConsole('notification_type_title_order'),
			count: instanceNotification.listCoreUnread.length,
		},
		{
			id: NotificationTab.NOTIFICATION_TYPE_ACCOUNT,
			type: NotificationType.account,
			name: getTextFromConsole('notification_type_title_account'),
			count: instanceNotification.listAccountUnread.length,
		},
	]
})

function changeTab(tab: NotificationTab, type: NotificationType) {
	instanceNotification.setTab(tab)
	instanceNotification.setType(type)
}

function getTabName(typeInfo: { name: string; count: number }) {
	if (!typeInfo.count) return `${typeInfo.name}`
	if (typeInfo.count > 99) return `${typeInfo.name} (99+)`
	return `${typeInfo.name} (${typeInfo.count})`
}
</script>

<template>
	<div class="bs-notification-tab">
		<BsTabContainer
			ref="tabs"
			:isShowDesktopSection="false"
			:isHideDivideBetweenTabs="true"
			v-cloak
		>
			<template v-cloak #default>
				<BsTab
					v-for="type in typeList"
					class="bs-tab--fix"
					:key="type.id"
					:is-underline="instanceNotification.currentTab === type.id"
					@click="changeTab(type.id, type.type)"
				>
					<div class="bs-tab-desc">{{ getTabName(type) }}</div>
				</BsTab>
			</template>
		</BsTabContainer>
	</div>
</template>
